import React from 'react';

import {registrationService} from '../services/Registration.service';
import {RegistrationContext} from './registration.context';

export const RegistrationProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => (
    <RegistrationContext.Provider value={registrationService}>
        {children}
    </RegistrationContext.Provider>
);
